import { isValid } from 'date-fns';
import { dateHandle } from '../date';

export const dateValidator = (value: string) =>
  dateHandle({
    value,
    failure: () => false,
    success: isValid,
  });
